import {required} from "vuelidate/lib/validators";  
const news = {
    data() { 
      return {   
        newsData: { 
          Title: "", 
          Description: "", 
          Newstype: 0,
          SeoTitle: "", 
          SeoKeyword: "", 
          SeoDescription: "", 
          Islightbox:false,
          Imagegallery: "", 
          Startdate:"",
          Enddate:"",
          Websiteid: "", 
          Deleted: false, 
          }, 
  
          FormDataType:{
            Title:{FieldName:"Title",Field:"input",FieldTitle:this.$t('news.AddEdit.Title')},  
            Description:{FieldName:"Description",Field:"input",FieldTitle:this.$t('news.AddEdit.Description')},  
            Newstype:{FieldName:"Newstype",Field:"input",FieldTitle:this.$t('news.AddEdit.Newstype'),ComboDataArray:[]}, 
            SeoTitle:{FieldName:"SeoTitle",Field:"input",FieldTitle:this.$t('news.AddEdit.SeoTitle')}, 
            SeoKeyword:{FieldName:"SeoKeyword",Field:"input",FieldTitle:this.$t('news.AddEdit.SeoKeyword')}, 
            SeoDescription:{FieldName:"SeoDescription",Field:"input",FieldTitle:this.$t('news.AddEdit.SeoDescription')}, 
            Islightbox:{FieldName:"Islightbox",Field:"checkbox",FieldTitle: this.$t('news.AddEdit.Islightbox')},
            Imagegallery:{FieldName:"Imagegallery",Field:"input",FieldTitle:this.$t('news.AddEdit.Imagegallery')}, 
            Startdate:{FieldName:"Startdate",Field:"input",FieldTitle:this.$t('news.AddEdit.Startdate'),FieldType:"text"},
            Enddate:{FieldName:"Enddate",Field:"input",FieldTitle:this.$t('news.AddEdit.Enddate'),FieldType:"text"},
            Websiteid:{FieldName:"Websiteid",Field:"input"},           

          } ,
          duyuru_tipleri: [
            { Id:"1",  Value:"Duyuru" },
            { Id:"2",  Value:"Haber" }, 
          ]
      }
    },  
    validations:{ 
      FormData: {  
        Title: {required},   
        Description: {required},  
        Newstype:{required},   
        SeoTitle: {},  
        SeoKeyword: {},   
        SeoDescription: {},  
        Islightbox:{},  
        Startdate: {required},   
        Enddate: {required}, 
        Imagegallery: {},  
        Websiteid: {required},   
  
      }
 
  },
  created(){

            for (var i = 0; i < this.duyuru_tipleri.length; i++) {
              this.FormDataType.Newstype.ComboDataArray.push({
                Id: this.duyuru_tipleri[i].Id,
                Value: this.duyuru_tipleri[i].Value,
              });
            }         

  }
}
export default news